import type { WorkOrderDateFacetApi } from 'types/api/work-order/workOrderFacets'

export interface RouteDayMeta {
  hasRoute: boolean
  hasUnassignedRoute: boolean
  count: number
  unassignedCount: number
  routeName: string | null
  routeColor: string | null
}

// Both calendar hooks derive this and drifted once: one dropped unassignedCount, blanking the day.
export const toRouteDayMeta = (row: WorkOrderDateFacetApi): RouteDayMeta => {
  const assignedCount = row.count - row.unassignedCount
  return {
    hasRoute: assignedCount > 0,
    hasUnassignedRoute: row.unassignedCount > 0,
    count: assignedCount,
    unassignedCount: row.unassignedCount,
    routeName: row.routeName ?? null,
    routeColor: row.routeColor ?? null,
  }
}
